import React, {
  useState,
  useEffect,
  createContext,
  Context,
  useCallback,
} from 'react';
import {until} from '../helpers/helpers';
import {
  fetchUserDetails,
  fetchProfileInfo,
  fetchUserAccessPermissions,
  fetchEmployeeDetails,
} from '../apis/auth.api';
import {USER_ACCESS_SCHEMA} from '../helpers/constants';
import {useIsFirstRender} from 'components/customHooks/isFirstRender';
import moment from 'moment';
import i18n from 'i18n';
// import {ERPAuthorization} from 'Authorization';
import {toastService} from 'erp-react-components';
import {OAuthImplementation} from 'OAuthImpl/index';

const FEATURE_NAMES = {
  REPORTS: 'Reports',
  HIERARCHY: 'Hierarchy',
  PROFILE: 'Profile',
  GROUPS: 'Groups',
  DEPARTMENT: 'Department',
  HOLIDAYS: 'Holidays',
  LEAVES: 'Leaves',
  SETTINGS: 'Settings',
  HOLIDAY_LIST: 'Holiday List',
  LEAVE_MASTER: 'Leave Master',
  REQUESTS: 'Requests',
  SKILL_MANAGEMENT: 'Skill Management',
  ASSET_MANAGEMENT: 'Asset Management',
  USER_ACCESS: 'User Access',
  ACCESS_GROUPS: 'Access Groups',
  USERS: 'Users',
  BRANCHES: 'Branches',
  COMPANY_INFORMATION: 'Company Information',
};
// console.dir(FEATURE_NAMES);

/**
 * @type {Context<{selectedSubordinate:string,isLoggedIn:boolean,isCandidateLoggedIn:boolean, loadUserDetails:()=>void,checkLogin:()=>void,checkLogin:()=>void,userDetails:UserDetails.RootObject,canView:accessValues,canEdit:accessValues,canDelete:accessValues,canAdd:accessValues,profileSettings:{dateFormat:string},helpers:{ dateStr:(u:string,options:Object)=>string,timeStr:(u:string)=>string,dateTimeStr:(u:string,{format}:{format:string})=>string}}>}
 */
export const AuthContext = createContext({
  selectedSubordinate: '',
  isLoggedIn: null,
  isCandidateLoggedIn: false,
  loadUserDetails: () => {
    // eslint-disable-next-line no-console
    console.log('load user details not updated');
  },
  checkLogin: () => {
    // eslint-disable-next-line no-console
    console.log('check login not updated');
  },
  loadprofileSettings: () => {},
  userDetails: {},
  canView: {},
  canEdit: {},
  canDelete: {},
  canAdd: {},
  profileSettings: {
    timeZone: '',
    timeFormat: '12Hours',
    nameFormat: '',
    dateFormat: 'yyyy-MM-dd',
    id: '',
  },
  helpers: {
    dateStr: (utcDate, options) => {
      return '';
    },
    timeStr: (time) => {
      return '';
    },
    dateTimeStr: (utcDateTime, options) => {
      return '';
    },
  },
  changeLanguage: (langDetails) => {
    localStorage.setItem('choosen_language', JSON.stringify(langDetails));
    window.CHOOSEN_LANGUAGE = langDetails;
    i18n.changeLanguage(langDetails.value);
  },
  setHRMSSettings: () => {},
  hrmsSettings: {},
  handleLogout: () => {
    console.error('authprovider not initialized yet');
  },
});

export function AuthContextProvider(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [hrmsSettings, setHRMSSettings] = useState();
  const [isCandidateLoggedIn] = useState(null);
  const isFirstRender = useIsFirstRender();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const code = params.get('code');
  const emptyProfileDetails = {
    timeZone: '',
    timeFormat: '12Hours',
    nameFormat: '',
    dateFormat: 'yyyy-MM-dd',
    id: '',
  };
  const [profileSettings, setprofileSettings] = useState(emptyProfileDetails);
  const [userPermissions, setUserPermissions] = useState({});
  const [/**@type {UserDetails.RootObject} */ userDetails, setUserDetails] =
    useState({});
  const [selectedReportee, setSelectedReportee] = useState('');
  const [backendENVProperties, setBackendENVProperties] = useState(null);

  const [loginError, setLoginError] = useState('');
  const [oAuth2] = useState(
    OAuthImplementation({
      clientId: process.env.REACT_APP_clientId,
      OPServer: process.env.REACT_APP_OPServer,
      GatewayServer: process.env.REACT_APP_GatewayServer,
      redirectURL: process.env.REACT_APP_redirectURL,
      scope: process.env.REACT_APP_scope,
      userInfoEndpoint: process.env.REACT_APP_userInfoEndpoint,
      extra: process.env.REACT_APP_extra,
    }),
  );

  const changeLanguage = (langDetails) => {
    localStorage.setItem('choosen_language', JSON.stringify(langDetails));
    window.CHOOSEN_LANGUAGE = langDetails;
    i18n.changeLanguage(langDetails.value);
  };

  useEffect(() => {
    window.AUTH_STR = localStorage.getItem('awl_token');
    if (window.AUTH_STR === 'undefined') window.AUTH_STR = undefined;
    (async () => {
      if (localStorage.getItem('login-error')) {
        setLoginError(localStorage.getItem('login-error'));
        return;
      }

      if (!window.AUTH_STR) {
        oAuth2.hasRandomPrefix() //||oauth2.codeInUrl()
          ? oAuth2.completeAuth(() => {
              const returnUrl = localStorage.getItem('return-url');
              localStorage.removeItem('return-url');
              window.location.href = returnUrl || '/';
            })
          : (!localStorage.getItem('return-url') &&
              localStorage.setItem('return-url', window.location.pathname),
            oAuth2.sendToAuthServerPage());
        // await ERPAuthorization.getConfiguration();
        // ERPAuthorization.makeAuth(code);
      } else {
        checkLogin(() => {
          oAuth2.setUpTokenRefresh();
        });
      }
    })();
    return () => {};
  }, []);

  useEffect(() => {
    if (isFirstRender)
      return () => {
        // eslint-disable-next-line no-console
        console.log('after first render useffect update');
      };
    setIsLoggedIn(!!userDetails.id);
  }, [userDetails]);

  useEffect(() => {
    if (loginError) {
      setIsLoggedIn(false);
    }
  }, [loginError]);

  //fetch profile details

  async function getProfileDetails(userId) {
    userId = userId || (userDetails || {}).id;
    const [err, data] = await until(fetchProfileInfo(userId));
    if (err) {
      console.error(err);
      return;
    }
    const m = {
      ...emptyProfileDetails,
      ...(data.result[0] || {}),
      dateFormat:
        (data.result[0] || {}).dateFormat || emptyProfileDetails.dateFormat,
    };
    setprofileSettings(m); //merging the objects so that if result doesnot have a key, it will be emptystring instead of undefined
  }

  ///end of profile detail

  async function loadUserDetails(cb) {
    const [err, [userDetailsResponse, userPermissionsRes = {}]] = await until([
      fetchUserDetails(), // Promise.reject({message:'test error'}),
      // fetchUserAccessPermissions(),
    ]);
    const userDetailsRes = userDetailsResponse || {};
    localStorage.setItem('emailId', userDetailsRes?.emailId);
    if (err) {
      console.error(err);
      toastService.error({msg: err.message, manualClose: true});
      return setLoginError(err.message || 'Login Error');
    } else if (!userDetailsRes?.isLoginAllow) {
      return setLoginError(
        'you are currently not subscribed to the tool. Please contact your Administrator for access',
      );
    }
    const [empErr, [employeeResponse]] = await until([fetchEmployeeDetails()]);
    let lastName_ = '';
    (employeeResponse?.data?.name?.split(' ') || []).forEach((n, idx) => {
      if (idx > 0) {
        lastName_ += n + ' ';
      }
    });

    const filestName_ = employeeResponse?.data?.name
      ? employeeResponse?.data?.name?.split(' ')[0]
      : '';

    let obj = {
      emailId: employeeResponse?.data?.email || userDetailsRes?.emailId || '',
      employee_id:
        employeeResponse?.data?.employee_id ||
        userDetailsRes?.employee_id ||
        '',
      emp_id: userDetailsRes?.emp_id || '',
      mobile:
        employeeResponse?.data?.mobile || userDetailsRes?.officePhone || '',
      id: employeeResponse?.data?.employee_id || userDetailsRes?.id || '',
      profile_pic: employeeResponse?.data?.profile_pic || '',
      user_type: employeeResponse?.data?.user_type || '',
      location: userDetailsRes?.location.name || '',
      locationId: userDetailsRes?.locationId || '',
      department: userDetailsRes?.department || '',
    };
    if (
      employeeResponse?.data?.personal_info?.first_name ||
      employeeResponse?.data?.personal_info?.last_name
    ) {
      obj = {
        ...obj,
        firstName: employeeResponse?.data?.personal_info?.first_name || '',
        lastName:
          employeeResponse?.data?.personal_info?.last_name?.trim() || '',
        middleName: employeeResponse?.data?.personal_info?.middle_name || '',
      };
    } else {
      obj = {
        ...obj,
        firstName: userDetailsRes?.firstName || '',
        lastName: userDetailsRes?.lastName || '',
        middleName: userDetailsRes?.middleName || '',
      };
    }
    setUserDetails(obj);
    const currentUserId = userDetailsRes.id;
    localStorage.setItem('currentUserId', currentUserId);
    localStorage.setItem(
      'empName',
      `${obj?.firstName} ${obj?.middleName} ${obj?.lastName}`,
    );
    localStorage.setItem('userDetails', JSON.stringify(userDetailsRes));
    cb && cb();
    if (userDetailsRes.id) {
      getProfileDetails(userDetailsRes.id);
      setUserPermissions(userPermissionsRes);
    } else
      console.error('no user id to fetch profile settings - ', userDetailsRes);
  }

  function checkLogin(cb) {
    loadUserDetails(cb);
  }

  const getAccessVals = useCallback(() => {
    const isAdmin = userDetails ? userDetails.isAdmin : false;
    const canView = {};
    const access = {};
    access.canEdit = {};
    access.canAdd = {};
    access.canDelete = {};
    access.canView = canView;
    const keys = {
      canView: 'isView',
      canEdit: 'isEdit',
      canAdd: 'isAdd',
      canDelete: 'isEdit', // changed the value to isEdit since response no longer as isDelete and no need to change the permissions for canDelete in each and every file
    };
    const accessTypes = Object.keys(access);
    if (userPermissions.permissions) {
      const payroll = (userPermissions.permissions || []).find(
        (p) => p.name.toLowerCase() === 'payroll',
      );

      accessTypes.forEach((action) => {
        access[action].payroll = payroll
          ? (payroll.permissions || {})[keys[action]]
          : false;
      });

      if (payroll && payroll.features) {
        const payroll_reports = payroll.features.find(
          (f) => f.name.toLowerCase() === 'reports',
        );
        accessTypes.forEach((action) => {
          access[action].payroll_reports = payroll_reports
            ? (payroll_reports.permissions || {})[keys[action]]
            : false;
        });
        const payroll_salary_information = payroll.features.find(
          (f) => f.name.toLowerCase() === 'salary information',
        );
        accessTypes.forEach((action) => {
          access[action].payroll_salary_information = payroll_salary_information
            ? (payroll_salary_information.permissions || {})[keys[action]]
            : false;
        });
        const payroll_new_employee_salary =
          payroll_salary_information.features.find(
            (f) => f.name.toLowerCase() === 'new employee salary',
          );
        accessTypes.forEach((action) => {
          access[action].payroll_new_employee_salary =
            payroll_new_employee_salary
              ? (payroll_new_employee_salary.permissions || {})[keys[action]]
              : false;
        });
        const payroll_salary_information_import =
          payroll_salary_information.features.find(
            (f) => f.name.toLowerCase() === 'import',
          );
        accessTypes.forEach((action) => {
          access[action].payroll_salary_information_import =
            payroll_salary_information_import
              ? (payroll_salary_information_import.permissions || {})[
                  keys[action]
                ]
              : false;
        });
      } else {
        accessTypes.forEach((t) => {
          access[t].payroll = false;
          access[t].payroll_reports = false;
          access[t].payroll_salary_information = false;
          access[t].payroll_new_employee_salary = false;
          access[t].payroll_salary_information_import = false;
        });
      }
    }

    if (isAdmin) {
      for (var type in access) {
        const reportsRemovedList = [
          'ams_reports',
          'ums_reports',
          'lms_reports',
        ];
        for (var i in access[type]) {
          access[type][i] = reportsRemovedList.some((a) => a === i)
            ? false
            : true;
        }
      }
    }
    // return { canView };
    return access;
  }, [userDetails, userPermissions]);

  const handleLogout = async (endSession = true) => {
    oAuth2
      .revokeToken(window.AUTH_STR)
      .then((success) => {
        if (!success) {
          failedCallback();
        }
        successCallback();
      })
      .catch((err) => {
        console.error(err);
        successCallback();
        // failedCallback()//todo: fix the api and use failedcb instead of successcb
      });

    function successCallback() {
      const url = `${
        process.env.REACT_APP_OPServer
      }/oxauth/restv1/end_session?post_logout_redirect_uri=${
        process.env.REACT_APP_redirectURL
      }&id_token_hint=${localStorage.getItem('id_token')}`;
      [
        'awl_token',
        'refresh_token',
        'logging_out_due_to_auth_error',
        'id_token',
        'empName',
        'currentUserId',
        'userDetails',
        'login-error',
      ].forEach((name) => localStorage.removeItem(name));
      if (endSession) {
        window.location = url;
      }
    }

    function failedCallback() {
      return toastService.error({
        msg: 'An error occured while logging out',
      });
    }
  };
  window.logout = handleLogout; //to be able to use in api_client.js

  async function loadprofileSettings() {
    setprofileSettings(
      JSON.parse(localStorage.getItem('profileSettings')) || {},
    );
  }

  const {canView, canAdd, canEdit, canDelete} = getAccessVals();

  const helpers = {
    timeStr: (utcDate, {sourceFormat, format} = {}) => {
      // without sourceFormat, assume isoString
      const mDate = moment(moment.utc(utcDate, sourceFormat || null));
      return (
        profileSettings.timeZone
          ? mDate.tz(profileSettings.timeZone)
          : mDate.local()
      ).format(
        format ||
          (profileSettings.timeFormat ? profileSettings.dateFormat : 'hh:mm a'),
      );
    },
    dateStr: (utcDate, {format, sourceFormat} = {}) => {
      const mDate = moment(moment.utc(utcDate, sourceFormat || null));
      return (
        profileSettings.timeZone
          ? mDate.tz(profileSettings.timeZone)
          : mDate.local()
      ).format(
        format ||
          (profileSettings.dateFormat
            ? profileSettings.dateFormat.toUpperCase()
            : 'YYYY-MM-DD'),
      );
    },
    dateTimeStr: (utcDateTime, {format} = {}) => {
      const mDate = moment(moment.utc(utcDateTime));

      return (
        profileSettings.timeZone
          ? mDate.tz(profileSettings.timeZone)
          : mDate.local()
      ).format(
        format ||
          (profileSettings.dateFormat
            ? profileSettings.dateFormat.toUpperCase()
            : 'yyyy-MM-dd hh:mm A'),
      );
    },
  };

  return (
    <AuthContext.Provider
      value={{
        selectedReportee,
        setSelectedReportee,
        loginError,
        setUserDetails,
        loadUserDetails,
        userDetails,
        checkLogin,
        isLoggedIn,
        isCandidateLoggedIn,
        loadprofileSettings,
        getProfileDetails,
        profileSettings,
        canView: canView || {},
        canAdd: canAdd || {},
        canEdit: canEdit || {},
        canDelete: canDelete || {},
        helpers,
        changeLanguage,
        setHRMSSettings,
        hrmsSettings,
        handleLogout,
        backendENVProperties,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}
